import type { BillingUsage } from "@nlkb/api-contract/billing";
import { useMutation } from "@tanstack/react-query";

import { workspaceBillingBannerKind } from "../account-billing";
import { useApi } from "../api-context";
import { followHostedHttpsUrl } from "../hosted-https";

export function BillingWorkspaceBanner({
  usage,
  organizationId,
  organizationRole,
}: {
  readonly usage: BillingUsage;
  readonly organizationId: string;
  readonly organizationRole: "org_owner" | "org_admin" | "member" | undefined;
}) {
  const api = useApi();
  const kind = workspaceBillingBannerKind(usage, organizationRole);
  const openPortal = useMutation({
    mutationFn: () =>
      api.billingPortal(usage.billing_account_id, organizationId),
    onSuccess: async (result) => {
      await followHostedHttpsUrl(result.portal_url);
    },
  });

  if (kind === null) return null;

  return (
    <div className="workspace-billing-banner" role="status">
      <p>
        Payment failed. Update your payment method to keep the subscription
        current.
      </p>
      {usage.billing_mode === "stripe" && usage.has_stripe_customer ? (
        <button
          className="secondary-action"
          type="button"
          disabled={openPortal.isPending}
          onClick={() => {
            openPortal.mutate();
          }}
        >
          {openPortal.isPending ? "Opening…" : "Update payment"}
        </button>
      ) : null}
      {openPortal.isError ? (
        <p className="form-error" role="alert">
          {openPortal.error.message.replaceAll("_", " ")}
        </p>
      ) : null}
    </div>
  );
}
